import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Breadcrumbs() {
    const location = useLocation();
    const path = location.pathname;

    let breadcrumbs;

    const baseLinkClass = "text-slate-500 dark:text-[#92a4c9] text-sm font-medium hover:text-primary transition-colors";
    const activeTextClass = "text-slate-900 dark:text-white text-sm font-medium";
    const separatorClass = "text-slate-400 dark:text-[#92a4c9] text-sm font-medium";

    if (path === '/') {
        breadcrumbs = (
            <span className={activeTextClass}>Home</span>
        );
    } else if (path === '/experience') {
        breadcrumbs = (
            <>
                <Link className={baseLinkClass} to="/">Home</Link>
                <span className={separatorClass}>/</span>
                <span className={activeTextClass}>Projects &amp; Experience</span>
            </>
        );
    } else if (path === '/education') {
        breadcrumbs = (
            <>
                <Link className={baseLinkClass} to="/">Home</Link>
                <span className={separatorClass}>/</span>
                <span className={activeTextClass}>Education</span>
            </>
        );
    } else if (path === '/contact') {
        breadcrumbs = (
            <>
                <Link className={baseLinkClass} to="/">Home</Link>
                <span className={separatorClass}>/</span>
                <span className={activeTextClass}>Contact</span>
            </>
        );
    } else {
        // Fallback or 404
        breadcrumbs = (
            <>
                <Link className={baseLinkClass} to="/">Home</Link>
            </>
        );
    }

    return (
        <nav className="flex items-center gap-2 mb-6">
            {breadcrumbs}
        </nav>
    );
}

export default Breadcrumbs;
